<template>
  <div class="user-orders">
    <!-- 引入订单详情处理组件 -->
    <UserOrderComponent ref="orderDetailComponent" />
    
    <!-- 引入订单编辑组件 -->
    <UserOrderEditComponent ref="orderEditComponent" @update="handleEditSuccess" @cancel="handleEditCancel" />
    
    <!-- 订单列表标题栏 -->
    <div class="order-list-header">
      <div class="order-title">订单列表</div>
    </div>
    
    <!-- 选项卡切换 -->
    <div class="tabs-container">
      <div class="arrow left-arrow" @click="scrollTabs('left')" v-show="showLeftArrow && screenWidth < 400">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <div class="order-tabs" ref="tabsContainer">
        <div :class="['tab-item', activeTab === 'regular' ? 'active' : '']" @click="switchTab('regular')">
          超主点订单
        </div>
        <div :class="['tab-item', activeTab === 'fuxiangsan' ? 'active' : '']" @click="switchTab('fuxiangsan')">
          其他订单
        </div>
        <div :class="['tab-item', activeTab === 'bulk' ? 'active' : '']" @click="switchTab('bulk')">
          批量订单
        </div>
      </div>
      <div class="arrow right-arrow" @click="scrollTabs('right')" v-show="showRightArrow && screenWidth < 400">
        <el-icon><ArrowRight /></el-icon>
      </div>
    </div>
    
    <!-- 筛选区域 -->
    <div class="filter-section">
      <el-date-picker
        v-model="selectedDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="YYYY-MM-DD"
        style="padding: 0;"
        class="date-picker-mobile"
      />
      <!-- 超主点订单查询条件，仅在超主点订单标签页显示 -->
      <template v-if="activeTab === 'regular'">
        <el-input v-model="selectedPatientName" placeholder="患者姓名" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <!-- 赋像散订单查询条件，仅在赋像散订单标签页显示 -->
      <template v-if="activeTab === 'fuxiangsan'">
        <el-input v-model="selectedPatientName" placeholder="患者姓名" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <!-- 批量订单查询条件，仅在批量订单标签页显示 -->
      <template v-if="activeTab === 'bulk'">
        <el-input v-model="selectedCompany" placeholder="验配单位" clearable style="width: 150px;"></el-input>
        <el-input v-model="selectedLensModel" placeholder="订单型号" clearable style="width: 150px;"></el-input>
      </template>
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="resetSearch" style="margin-left: 0">重置</el-button>
    </div>
    
    <!-- 常规订单内容区域 -->
    <div v-if="activeTab === 'regular'" class="content">
    <el-card>
      <template #header>
        <span>超主点订单管理</span>
      </template>
      <!-- PC端表格视图 -->
      <div class="table-container" v-if="!isMobile">
        <el-table :data="filteredOrders" style="width: 100%" border>
          <!-- 基本信息 -->
          <el-table-column label="序号" width="100" fixed="left">
            <template #default="scope">
              <!-- 从1开始计算序号，并考虑分页偏移 -->
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>

          <!-- 订单基本信息 -->
          <el-table-column label="订单基本信息" align="center">
            <el-table-column prop="orderType" label="订单类型" width="100"></el-table-column>
            <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
            <el-table-column prop="patientName" label="患者姓名" width="120"></el-table-column>
            <el-table-column prop="optometrist" label="验光师" width="100"></el-table-column>
            <el-table-column prop="region" label="地区" width="100"></el-table-column>
            <el-table-column prop="lensModel" label="订单型号" width="120"></el-table-column>
            <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
            <el-table-column prop="purchasingUnits" label="采购单位" width="120"></el-table-column>
          </el-table-column>

          <!-- 常规验光数据 -->
          <el-table-column label="常规验光" align="center">
            <el-table-column label="右眼" align="center">
              <el-table-column label="球镜" width="80">
                <template #default="scope">
                  {{ scope.row.regularOdSphere > 0 ? '+' + scope.row.regularOdSphere : scope.row.regularOdSphere }}
                </template>
              </el-table-column>
              <el-table-column prop="regularOdCylinder" label="柱镜" width="80"></el-table-column>
              <el-table-column prop="regularOdAxis" label="轴位" width="80"></el-table-column>
              <el-table-column prop="regularOdVision" label="视力" width="80"></el-table-column>
            </el-table-column>
            <el-table-column label="左眼" align="center">
              <el-table-column label="球镜" width="80">
                <template #default="scope">
                  {{ scope.row.regularOsSphere > 0 ? '+' + scope.row.regularOsSphere : scope.row.regularOsSphere }}
                </template>
              </el-table-column>
              <el-table-column prop="regularOsCylinder" label="柱镜" width="80"></el-table-column>
              <el-table-column prop="regularOsAxis" label="轴位" width="80"></el-table-column>
              <el-table-column prop="regularOsVision" label="视力" width="80"></el-table-column>
            </el-table-column>
            <el-table-column prop="regularBinocularFusion" label="双眼融像" width="120"></el-table-column>
            <el-table-column prop="regularStereoscopicVisionFunction" label="立体视功能" width="120"></el-table-column>
            <el-table-column prop="regularBinocularVision" label="双眼视力" width="100"></el-table-column>
          </el-table-column>

          <!-- 超主点验光数据 -->
          <el-table-column label="超主点验光" align="center">
            <el-table-column label="右眼" align="center">
              <el-table-column label="球镜" width="80">
                <template #default="scope">
                  {{ scope.row.superOdSphere > 0 ? '+' + scope.row.superOdSphere : scope.row.superOdSphere }}
                </template>
              </el-table-column>
              <el-table-column prop="superOdCylinder" label="柱镜" width="80"></el-table-column>
              <el-table-column prop="superOdAxis" label="轴位" width="80"></el-table-column>
              <el-table-column prop="superOdVision" label="视力" width="80"></el-table-column>
              <el-table-column prop="odQuantity" label="数量" width="80"></el-table-column>
            </el-table-column>
            <el-table-column label="左眼" align="center">
              <el-table-column label="球镜" width="80">
                <template #default="scope">
                  {{ scope.row.superOsSphere > 0 ? '+' + scope.row.superOsSphere : scope.row.superOsSphere }}
                </template>
              </el-table-column>
              <el-table-column prop="superOsCylinder" label="柱镜" width="80"></el-table-column>
              <el-table-column prop="superOsAxis" label="轴位" width="80"></el-table-column>
              <el-table-column prop="superOsVision" label="视力" width="80"></el-table-column>
              <el-table-column prop="osQuantity" label="数量" width="80"></el-table-column>
            </el-table-column>
            <el-table-column prop="superBinocularFusion" label="双眼融像" width="120"></el-table-column>
            <el-table-column prop="superStereoscopicVisionFunction" label="立体视功能" width="120"></el-table-column>
            <el-table-column prop="superBinocularVision" label="双眼视力" width="100"></el-table-column>
          </el-table-column>

          <!-- 角膜曲率 -->
          <el-table-column label="角膜曲率" align="center">
            <el-table-column label="右眼" align="center">
              <el-table-column prop="odK1" label="K1" width="80"></el-table-column>
              <el-table-column prop="odK2" label="K2" width="80"></el-table-column>
              <el-table-column prop="odAxialLength" label="眼轴" width="80"></el-table-column>
              <el-table-column prop="odChoroidalThickness" label="脉络膜厚度" width="100"></el-table-column>
            </el-table-column>
            <el-table-column label="左眼" align="center">
              <el-table-column prop="osK1" label="K1" width="80"></el-table-column>
              <el-table-column prop="osK2" label="K2" width="80"></el-table-column>
              <el-table-column prop="osAxialLength" label="眼轴" width="80"></el-table-column>
              <el-table-column prop="osChoroidalThickness" label="脉络膜厚度" width="100"></el-table-column>
            </el-table-column>
          </el-table-column>

          <!-- 眼镜参数 -->
          <el-table-column label="眼镜参数" align="center">
            <el-table-column label="右眼" align="center">
              <el-table-column prop="odPupilHeight" label="瞳高" width="80"></el-table-column>
              <el-table-column prop="odPupilDistance" label="瞳距" width="80"></el-table-column>
            </el-table-column>
            <el-table-column label="左眼" align="center">
              <el-table-column prop="osPupilHeight" label="瞳高" width="80"></el-table-column>
              <el-table-column prop="osPupilDistance" label="瞳距" width="80"></el-table-column>
            </el-table-column>
            <el-table-column prop="binocularPupilDistance" label="双眼瞳距" width="100"></el-table-column>
            <el-table-column prop="frameNumber" label="镜框编号" width="100"></el-table-column>
          </el-table-column>

          <!-- 邮寄信息 -->
          <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
          <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
          <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
          <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
          <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
          <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

          <!-- 操作列 -->
          <el-table-column label="操作" width="350" fixed="right">
            <template #default="scope">
              <el-button size="small" type="primary" @click="showOrderDetails(scope.row)">查看详情</el-button>
              <el-button size="small" type="success" @click="handleEdit(scope.row)">编辑订单</el-button>
              <el-button size="small" type="danger" @click="handleDelete(scope.row)">取消</el-button>
              <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 移动端卡片视图 -->
      <div class="mobile-cards-container" v-else>
        <OrderMobileCard
          v-for="(item, index) in filteredOrders"
          :key="item.id"
          :item="item"
          :index="index"
          :current-page="currentPage"
          :page-size="pageSize"
          order-type="regular"
          :showCheckbox="false"
          :title="'订单号: ' + (item.orderNumber || '无')"
          @details="showOrderDetails"
          class="user-order-card"
        >
          <template #header-tag>
            <!-- 不显示导出状态标签 -->
            <span></span>
          </template>
          <template #actions>
            <el-button size="small" type="primary" @click="showOrderDetails(item)" class="details-btn">查看详情</el-button>
            <el-button size="small" type="success" @click="handleEdit(item)" class="details-btn">编辑订单</el-button>
            <el-button size="small" type="danger" @click="handleDelete(item)" class="details-btn">取消</el-button>
            <el-button size="small" type="info" @click="checkTracking(item)" v-if="item.trackingNumber" class="tracking-btn">查询物流</el-button>
          </template>
        </OrderMobileCard>
        
        <!-- 没有数据时显示 -->
        <el-empty v-if="filteredOrders.length === 0" description="没有找到订单数据"></el-empty>
      </div>
    </el-card>
    <div class="pagination-wrapper">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :pager-count="isMobile ? 3 : 7"
          layout="total, sizes, -> , prev, pager, next, jumper"
          :total="totalItems"
          background
      >
      </el-pagination>
    </div>
    </div>
    <div v-if="activeTab === 'fuxiangsan'" class="content">
      <el-card>
        <template #header>
          <span>其他订单管理</span>
        </template>
        <!-- PC端表格视图 -->
        <div class="table-container" v-if="!isMobile">
          <el-table :data="filteredFuxiangsanOrders" style="width: 100%" border>
            <!-- 基本信息 -->
            <el-table-column label="序号" width="100" fixed="left">
              <template #default="scope">
                <!-- 从1开始计算序号，并考虑分页偏移 -->
                {{ scope.$index + 1 + (fuxiangsanCurrentPage - 1) * fuxiangsanPageSize }}
              </template>
            </el-table-column>
            <!-- 订单基本信息 -->
            <el-table-column label="订单基本信息" align="center">
              <el-table-column prop="orderType" label="订单类型" width="100"></el-table-column>
              <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
              <el-table-column prop="patientName" label="患者姓名" width="120"></el-table-column>
              <el-table-column prop="optometrist" label="验光师" width="100"></el-table-column>
              <el-table-column prop="region" label="地区" width="100"></el-table-column>
              <el-table-column prop="lensModel" label="订单型号" width="120"></el-table-column>
              <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
              <el-table-column prop="purchasingUnits" label="采购单位" width="120"></el-table-column>
            </el-table-column>

            <!-- 常规验光数据 -->
            <el-table-column label="常规验光" align="center">
              <el-table-column label="右眼" align="center">
                <el-table-column label="球镜" width="80">
                  <template #default="scope">
                    {{ scope.row.regularOdSphere > 0 ? '+' + scope.row.regularOdSphere : scope.row.regularOdSphere }}
                  </template>
                </el-table-column>
                <el-table-column prop="regularOdCylinder" label="柱镜" width="80"></el-table-column>
                <el-table-column prop="regularOdAxis" label="轴位" width="80"></el-table-column>
                <el-table-column prop="regularOdVision" label="视力" width="80"></el-table-column>
              </el-table-column>
              <el-table-column label="左眼" align="center">
                <el-table-column label="球镜" width="80">
                  <template #default="scope">
                    {{ scope.row.regularOsSphere > 0 ? '+' + scope.row.regularOsSphere : scope.row.regularOsSphere }}
                  </template>
                </el-table-column>
                <el-table-column prop="regularOsCylinder" label="柱镜" width="80"></el-table-column>
                <el-table-column prop="regularOsAxis" label="轴位" width="80"></el-table-column>
                <el-table-column prop="regularOsVision" label="视力" width="80"></el-table-column>
              </el-table-column>
              <el-table-column prop="regularBinocularVision" label="双眼视力" width="100"></el-table-column>
            </el-table-column>

            <!-- 赋像散验光数据 -->
            <el-table-column label="赋像散验光" align="center">
              <el-table-column label="右眼" align="center">
                <el-table-column label="球镜" width="80">
                  <template #default="scope">
                    {{ scope.row.superOdSphere > 0 ? '+' + scope.row.superOdSphere : scope.row.superOdSphere }}
                  </template>
                </el-table-column>
                <el-table-column prop="superOdCylinder" label="柱镜" width="80"></el-table-column>
                <el-table-column prop="superOdAxis" label="轴位" width="80"></el-table-column>
                <el-table-column prop="superOdVision" label="视力" width="80"></el-table-column>
                <el-table-column prop="odQuantity" label="数量" width="80"></el-table-column>
              </el-table-column>
              <el-table-column label="左眼" align="center">
                <el-table-column label="球镜" width="80">
                  <template #default="scope">
                    {{ scope.row.superOsSphere > 0 ? '+' + scope.row.superOsSphere : scope.row.superOsSphere }}
                  </template>
                </el-table-column>
                <el-table-column prop="superOsCylinder" label="柱镜" width="80"></el-table-column>
                <el-table-column prop="superOsAxis" label="轴位" width="80"></el-table-column>
                <el-table-column prop="superOsVision" label="视力" width="80"></el-table-column>
                <el-table-column prop="osQuantity" label="数量" width="80"></el-table-column>
              </el-table-column>
              <el-table-column prop="superBinocularVision" label="双眼视力" width="100"></el-table-column>
            </el-table-column>

            <!-- 角膜曲率 -->
            <el-table-column label="角膜曲率" align="center">
              <el-table-column label="右眼" align="center">
                <el-table-column prop="odK1" label="K1" width="80"></el-table-column>
                <el-table-column prop="odK2" label="K2" width="80"></el-table-column>
                <el-table-column prop="odAxialLength" label="眼轴" width="80"></el-table-column>
              </el-table-column>
              <el-table-column label="左眼" align="center">
                <el-table-column prop="osK1" label="K1" width="80"></el-table-column>
                <el-table-column prop="osK2" label="K2" width="80"></el-table-column>
                <el-table-column prop="osAxialLength" label="眼轴" width="80"></el-table-column>
              </el-table-column>
            </el-table-column>

            <!-- 眼镜参数 -->
            <el-table-column label="眼镜参数" align="center">
              <el-table-column label="右眼" align="center">
                <el-table-column prop="odPupilHeight" label="瞳高" width="80"></el-table-column>
                <el-table-column prop="odPupilDistance" label="瞳距" width="80"></el-table-column>
              </el-table-column>
              <el-table-column label="左眼" align="center">
                <el-table-column prop="osPupilHeight" label="瞳高" width="80"></el-table-column>
                <el-table-column prop="osPupilDistance" label="瞳距" width="80"></el-table-column>
              </el-table-column>
              <el-table-column prop="binocularPupilDistance" label="双眼瞳距" width="100"></el-table-column>
              <el-table-column prop="frameNumber" label="镜框编号" width="100"></el-table-column>
            </el-table-column>
            <!--眼位-->
            <el-table-column label="眼位" align="center">
              <el-table-column prop="eyePositionFar" label="眼位(远)" width="80"></el-table-column>
              <el-table-column prop="eyePositionNear" label="眼位(近)" width="80"></el-table-column>
            </el-table-column>

            <!-- 邮寄信息 -->
            <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
            <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
            <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
            <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" width="350" fixed="right">
              <template #default="scope">
                <el-button size="small" type="primary" @click="showOrderDetails(scope.row)">查看详情</el-button>
                <el-button size="small" type="success" @click="handleEdit(scope.row)">编辑订单</el-button>
                <el-button size="small" type="danger" @click="handleDelete(scope.row)">取消</el-button>
                <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 移动端卡片视图 -->
        <div class="mobile-cards-container" v-else>
          <OrderMobileCard
            v-for="(item, index) in filteredFuxiangsanOrders"
            :key="item.id"
            :item="item"
            :index="index"
            :current-page="fuxiangsanCurrentPage"
            :page-size="fuxiangsanPageSize"
            order-type="fuxiangsan"
            :showCheckbox="false"
            :title="'订单号: ' + (item.orderNumber || '无')"
            @details="showOrderDetails"
            class="user-order-card"
          >
            <template #header-tag>
              <span></span>
            </template>
            <template #actions>
              <el-button size="small" type="primary" @click="showOrderDetails(item)" class="details-btn">查看详情</el-button>
              <el-button size="small" type="success" @click="handleEdit(item)" class="details-btn">编辑订单</el-button>
              <el-button size="small" type="danger" @click="handleDelete(item)" class="details-btn">取消</el-button>
              <el-button size="small" type="info" @click="checkTracking(item)" v-if="item.trackingNumber" class="tracking-btn">查询物流</el-button>
            </template>
          </OrderMobileCard>
          
          <!-- 没有数据时显示 -->
          <el-empty v-if="filteredFuxiangsanOrders.length === 0" description="没有找到订单数据"></el-empty>
        </div>
      </el-card>
      <div class="pagination-wrapper">
        <el-pagination
            @size-change="handleFuxiangsanSizeChange"
            @current-change="handleFuxiangsanCurrentChange"
            :current-page="fuxiangsanCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="fuxiangsanPageSize"
            :pager-count="isMobile ? 3 : 7"
            layout="total, sizes, -> , prev, pager, next, jumper"
            :total="fuxiangsanTotalItems"
            background
        >
        </el-pagination>
      </div>
    </div>
    <!-- 批量订单内容区域 -->
    <div v-if="activeTab === 'bulk'" class="content">
      <el-card>
        <template #header>
          <div class="bulk-header">
            <span>批量订单管理</span>
          </div>

        </template>
        <!-- PC端表格视图 -->
        <div class="table-container bulk-orders-table-container" v-if="!isMobile">
          <el-table :data="filteredBulkOrders" style="width: 100%" border class="bulk-orders-table">
            <!-- 基本信息 -->
            <el-table-column label="序号" width="80" fixed="left">
              <template #default="scope">
                <!-- 从1开始计算序号，并考虑分页偏移 -->
                {{ scope.$index + 1 + (bulkCurrentPage - 1) * bulkPageSize }}
              </template>
            </el-table-column>

            <!-- 订单基本信息 -->
            <el-table-column label="订单基本信息" align="center">
              <el-table-column prop="orderType" label="订单类型" width="100"></el-table-column>
              <el-table-column prop="orderDate" label="订单日期" width="120"></el-table-column>
              <el-table-column prop="region" label="地区" width="100"></el-table-column>
              <el-table-column prop="company" label="验配单位" width="120"></el-table-column>
              <el-table-column prop="lensModel" label="订单型号" width="150"></el-table-column>
              <el-table-column prop="quantity" label="数量" width="80"></el-table-column>
            </el-table-column>

            <!-- 邮寄信息 -->
            <el-table-column prop="addressee" label="收件人" width="150"></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="150"></el-table-column>
            <el-table-column prop="trackingNumber" label="物流编号" width="200"></el-table-column>
            <el-table-column prop="deliveryDate" label="邮寄日期" width="150"></el-table-column>
            <el-table-column prop="shippingAddress" label="邮寄地址" width="200"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="200"></el-table-column>

            <!-- 操作列 -->
            <el-table-column label="操作" width="350" fixed="right">
              <template #default="scope">
                <el-button size="small" type="primary" @click="showOrderDetails(scope.row)">查看详情</el-button>
                <el-button size="small" type="success" @click="handleEdit(scope.row)">编辑订单</el-button>
                <el-button size="small" type="danger" @click="handleDelete(scope.row)">取消</el-button>
                <el-button size="small" type="info" @click="checkTracking(scope.row)" v-if="scope.row.trackingNumber">查询物流</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <!-- 移动端卡片视图 -->
        <div class="mobile-cards-container" v-else>
          <OrderMobileCard
            v-for="(item, index) in filteredBulkOrders"
            :key="item.id"
            :item="item"
            :index="index"
            :current-page="bulkCurrentPage"
            :page-size="bulkPageSize"
            order-type="bulk"
            :showCheckbox="false"
            :title="'订单号: ' + (item.orderNumber || '无')"
            @details="showOrderDetails"
            class="user-order-card"
          >
            <template #header-tag>
              <span></span>
            </template>
            <template #actions>
              <el-button size="small" type="primary" @click="showOrderDetails(item)" class="details-btn">查看详情</el-button>
              <el-button size="small" type="success" @click="handleEdit(item)" class="details-btn">编辑订单</el-button>
              <el-button size="small" type="danger" @click="handleDelete(item)" class="details-btn">取消</el-button>
              <el-button size="small" type="info" @click="checkTracking(item)" v-if="item.trackingNumber" class="tracking-btn">查询物流</el-button>
            </template>
          </OrderMobileCard>
          
          <!-- 没有数据时显示 -->
          <el-empty v-if="filteredBulkOrders.length === 0" description="没有找到订单数据"></el-empty>
        </div>
      </el-card>
      <div class="pagination-wrapper">
        <el-pagination
            @size-change="handleBulkSizeChange"
            @current-change="handleBulkCurrentChange"
            :current-page="bulkCurrentPage"
            :page-sizes="[10, 20, 50, 100]"
            :pager-count="isMobile ? 3 : 7"
            :page-size="bulkPageSize"
            layout="total, sizes, -> , prev, pager, next, jumper"
            :total="bulkTotalItems"
            background
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<style scoped>
.user-orders {
  width: 100%;
}

/* 添加标签容器样式 */
.tabs-container {
  display: flex;
  align-items: center;
  position: relative;
  margin-bottom: 20px;
}

/* 箭头样式 */
.arrow {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f2f6fc;
  border-radius: 50%;
  cursor: pointer;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s;
}

.arrow:hover {
  background-color: #eaedf1;
}

.left-arrow {
  margin-right: 5px;
}

.right-arrow {
  margin-left: 5px;
}

.order-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.order-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.order-tabs {
  display: flex;
  flex: 1;
  overflow-x: hidden;
  scroll-behavior: smooth;
  border-bottom: 1px solid #eee;
}

.tab-item {
  padding: 10px 20px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.3s;
  margin-right: 20px;
  white-space: nowrap;
}

.tab-item:hover {
  color: #409EFF;
}

.tab-item.active {
  color: #409EFF;
  border-bottom-color: #409EFF;
  font-weight: bold;
}

.filter-section {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.content {
  width: 100%;
}

.el-card {
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.table-container {
  overflow-x: auto;
}

/* 添加表格单元格样式，确保内容不换行且超出显示省略号 */
:deep(.el-table .cell) {
  white-space: nowrap;      /* 禁止换行 */
  overflow: hidden;         /* 超出部分隐藏 */
  text-overflow: ellipsis;  /* 超出部分显示省略号 */
}

.el-table {
  width: 100%;
}

/* 分页器容器样式 */
.pagination-wrapper {
  margin-top: 20px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
}

/* 分页器组件样式调整 */
:deep(.el-pagination) {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: normal;
}

/* 总条数和每页条数样式 */
:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
  margin-right: 10px;
}

/* 页码样式 */
:deep(.el-pager) {
  padding: 0;
  margin: 0 5px;
}

:deep(.el-pager li) {
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
  margin: 0 2px;
  font-weight: normal;
}

:deep(.el-pager li.active) {
  background-color: #409EFF;
  color: white;
  font-weight: bold;
}

/* 前后页按钮样式 */
:deep(.btn-prev),
:deep(.btn-next) {
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  margin: 0 3px;
  padding: 0;
  border-radius: 2px;
}

/* 跳转框样式 */
:deep(.el-pagination__jump) {
  margin-left: 10px;
}

:deep(.el-pagination__editor.el-input) {
  width: 50px;
  margin: 0 5px;
}

/* 移动端卡片容器样式 */
.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 10px 0;
}

/* 用户订单卡片中的按钮样式 */
.user-order-card :deep(.card-actions) {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  padding: 12px;
}

/* 用户订单卡片中的单个按钮样式 */
.user-order-card :deep(.details-btn:only-child) {
  width: 80%;
  max-width: 200px;
}

/* 用户订单卡片中的多个按钮样式 */
.user-order-card :deep(.details-btn:not(:only-child)),
.user-order-card :deep(.tracking-btn) {
  width: 45%;
  max-width: 150px;
  margin: 0 5px;
}

/* 订单详情弹窗样式优化 */
:deep(.details-dialog) {
  width: 95% !important;
  max-width: 800px !important;
}

:deep(.details-dialog .el-message-box__content) {
  max-height: 70vh;
  overflow-y: auto;
  padding: 10px 15px;
}

/* 移动端日期选择器样式优化 */
.date-picker-mobile {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .user-orders {
    padding: 10px;
  }
  
  .order-list-header {
    padding: 10px;
  }
  
  .order-title {
    font-size: 18px;
  }
  
  /* 选项卡优化 */
  .tabs-container {
    padding: 0 5px;
  }
  
  .order-tabs {
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    margin-bottom: 0;
    flex: 1;
  }
  
  .tab-item {
    flex: 0 0 auto;
    padding: 8px 15px;
    font-size: 14px;
    white-space: nowrap;
  }
  
  /* 筛选区域优化 */
  .filter-section {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }
  
  .filter-section .el-select,
  .filter-section .el-date-picker,
  .date-picker-mobile {
    width: 100% !important;
  }
  
  .filter-section .el-button {
    margin-top: 5px;
    width: 100%;
  }
  
  /* 表格容器优化 */
  .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  /* 表格内按钮优化 */
  .el-table .el-button {
    padding: 6px 12px;
    margin: 3px 0;
    display: block;
    width: 100%;
  }
  
  .el-table th {
    padding: 8px 0;
  }
  
  .el-table td {
    padding: 5px 0;
  }
  
  /* 操作列按钮优化 */
  .el-table__fixed-right .el-button {
    min-width: 100%;
    margin: 3px 0;
  }
  
  /* 分页组件优化 */
  .pagination-wrapper {
    padding: 10px 5px;
    margin-top: 10px;
  }
  
  :deep(.el-pagination) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px 5px;
  }
  
  :deep(.el-pagination__total),
  :deep(.el-pagination__sizes) {
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
  }
  
  /* 移动卡片样式优化 */
  .mobile-cards-container {
    margin: 0 -5px;
  }

  /* 用户订单卡片在移动端的样式覆盖 */
  .user-order-card :deep(.card-actions) {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: center !important;
    padding: 12px !important;
    gap: 10px !important;
  }

  /* 用户订单卡片中的单个按钮在移动端样式 */
  .user-order-card :deep(.details-btn:only-child) {
    width: 90% !important;
    max-width: none !important;
  }

  /* 用户订单卡片中的多个按钮在移动端样式 */
  .user-order-card :deep(.details-btn:not(:only-child)),
  .user-order-card :deep(.tracking-btn) {
    width: 45% !important;
    max-width: none !important;
    margin: 0 !important;
  }
  
  /* 订单详情弹窗在移动端的优化 */
  :deep(.details-dialog) {
    width: 95% !important;
    max-width: 100% !important;
  }
  
  :deep(.details-dialog .el-message-box__content) {
    padding: 10px;
    font-size: 13px;
  }
}

/* 批量订单特定样式 */
.bulk-orders-table-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 15px;
}

.bulk-orders-table {
  min-width: 650px; /* 确保表格在小屏幕上可以横向滚动 */
}

.bulk-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* 增强移动端批量订单适配 */
@media screen and (max-width: 768px) {
  .bulk-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  
  .bulk-orders-table-container {
    margin: 0 -10px;
  }
  
  .bulk-operation-column {
    min-width: 70px !important;
    width: 70px !important;
  }
  
  /* 表格列宽度优化 */
  .bulk-orders-table .el-table__header th,
  .bulk-orders-table .el-table__body td {
    padding: 5px 3px;
  }
  
  .bulk-orders-table .el-table__header th .cell,
  .bulk-orders-table .el-table__body td .cell {
    padding-left: 5px;
    padding-right: 5px;
    font-size: 12px;
  }
  :deep(.el-pagination__rightwrapper) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap; /* 允许折行 */
    gap: 3px;
  }
}

/* 页码导航区域 - 与前后页按钮在同一行 */
:deep(.el-pagination__rightwrapper) {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
}


/* 跳转功能单独一行 */
:deep(.el-pagination__jump) {
  flex: 1 1 100%;
  margin-top: 8px;
  display: flex;
  justify-content: center;
  width: 100%;
}
</style>
  
<script setup>
import { ref, onMounted, computed, nextTick, watch, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue';
import axios from 'axios';
import { useMobileDetection } from '@/utils/mobileAdapter';
import OrderMobileCard from '../components/OrderMobileCard.vue';
import UserOrderComponent from '../components/UserOrderComponent.vue';  // 导入新组件
import UserOrderEditComponent from '../components/UserOrderEditComponent.vue';  // 导入编辑组件

const router = useRouter();
const activeTab = ref('regular'); // 'regular' 为普通订单, 'fuxiangsan' 为赋像散订单, 'bulk' 为批量订单
const selectedDate = ref(null);

// 订单详情组件引用
const orderDetailComponent = ref(null);
// 订单编辑组件引用
const orderEditComponent = ref(null);

// 屏幕宽度跟踪
const screenWidth = ref(window.innerWidth);

// 标签滚动相关
const tabsContainer = ref(null);
const showLeftArrow = ref(false);
const showRightArrow = ref(false);

//订单筛选条件
const selectedPatientName = ref('');
const selectedCompany = ref('');
const selectedLensModel = ref('');


// 更新屏幕宽度
const updateScreenWidth = () => {
  screenWidth.value = window.innerWidth;
  checkArrowsVisibility();
};

// 检查是否需要显示箭头
const checkArrowsVisibility = () => {
  if (!tabsContainer.value) return;
  
  const { scrollLeft, scrollWidth, clientWidth } = tabsContainer.value;
  
  // 确保有足够的内容可滚动且屏幕宽度小于400px
  const hasOverflow = scrollWidth > clientWidth;
  const isMobileSize = screenWidth.value < 400;
  
  // 如果不是移动尺寸，不显示箭头
  if (!isMobileSize) {
    showLeftArrow.value = false;
    showRightArrow.value = false;
    return;
  }
  
  // 如果可以向左滚动
  showLeftArrow.value = hasOverflow && scrollLeft > 0;
  // 如果可以向右滚动
  showRightArrow.value = hasOverflow && scrollLeft + clientWidth < scrollWidth;
};

// 滚动标签
const scrollTabs = (direction) => {
  if (!tabsContainer.value) return;
  
  const scrollAmount = 150; // 每次滚动的距离
  if (direction === 'left') {
    tabsContainer.value.scrollLeft -= scrollAmount;
  } else {
    tabsContainer.value.scrollLeft += scrollAmount;
  }
  
  // 滚动后重新检查箭头可见性
  setTimeout(checkArrowsVisibility, 300); // 等待滚动动画完成
};

// 使用移动端检测钩子
const { isMobile } = useMobileDetection(768);

// 普通订单数据
const allOrders = ref([]);
const currentPage = ref(1);
const pageSize = ref(10);
const totalItems = ref(0);

// 赋像散订单数据
const allFuxiangsanOrders = ref([]);
const fuxiangsanCurrentPage = ref(1);
const fuxiangsanPageSize = ref(10);
const fuxiangsanTotalItems = ref(0);

// 批量订单数据
const allBulkOrders = ref([]);
const bulkCurrentPage = ref(1);
const bulkPageSize = ref(10);
const bulkTotalItems = ref(0);

// 切换标签页
const switchTab = (tab) => {
  activeTab.value = tab;


  // 根据当前标签页加载对应数据
  if (tab === 'regular') {
    fetchOrders();
  } else if (tab === 'fuxiangsan') {
    fetchFuxiangsanOrders();
  } else if (tab === 'bulk') {
    fetchBulkOrders();
  }
};

// 普通订单筛选计算
const filteredOrders = computed(() => {
  if (!Array.isArray(allOrders.value)) {
    return [];
  }
  return [...allOrders.value];
});

// 赋像散订单筛选计算
const filteredFuxiangsanOrders = computed(() => {
  if (!Array.isArray(allFuxiangsanOrders.value)) {
    return [];
  }
  return [...allFuxiangsanOrders.value];
});

// 批量订单筛选计算
const filteredBulkOrders = computed(() => {
  if (!Array.isArray(allBulkOrders.value)) {
    return [];
  }
  return [...allBulkOrders.value];
});

// 普通订单分页处理
const handleCurrentChange = (val) => {
  currentPage.value = val;
  fetchOrders();
};

const handleSizeChange = (val) => {
  pageSize.value = val;
  currentPage.value = 1;
  fetchOrders();
};

// 赋像散订单分页处理
const handleFuxiangsanCurrentChange = (val) => {
  fuxiangsanCurrentPage.value = val;
  fetchFuxiangsanOrders();
};

const handleFuxiangsanSizeChange = (val) => {
  fuxiangsanPageSize.value = val;
  fuxiangsanCurrentPage.value = 1;
  fetchFuxiangsanOrders();
};

// 批量订单分页处理
const handleBulkCurrentChange = (val) => {
  bulkCurrentPage.value = val;
  fetchBulkOrders();
};

const handleBulkSizeChange = (val) => {
  bulkPageSize.value = val;
  bulkCurrentPage.value = 1;
  fetchBulkOrders();
};

// 普通订单查询
const fetchOrders = async () => {
  try {
    const userId = localStorage.getItem('userId')
    const params = {
      userId: userId,
      pageNum: currentPage.value,
      pageSize: pageSize.value,
    };
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }

    if (selectedPatientName.value) params.patientName = selectedPatientName.value;
    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;

    const response = await axios.get('/api/v1/user/order', {
      params,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allOrders.value = response.data.data || [];
      totalItems.value = response.data.totalRecords || 0;
      currentPage.value = response.data.pageNum || 1;
      pageSize.value = response.data.pageSize || 10;
    } else {
      ElMessage.error(response.data.info || '获取订单列表失败');
    }
  } catch (error) {
    console.error('获取订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取订单列表失败，请检查网络连接');
    }
  }
};

// 赋像散订单查询
const fetchFuxiangsanOrders = async () => {
  try {
    const userId = localStorage.getItem('userId')
    const params = {
      userId: userId,
      pageNum: fuxiangsanCurrentPage.value,
      pageSize: fuxiangsanPageSize.value,
    };
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }
    if (selectedPatientName.value) params.patientName = selectedPatientName.value;
    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;
    
    const response = await axios.get('/api/v1/user/scatterorder', {
      params,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allFuxiangsanOrders.value = response.data.data || [];
      fuxiangsanTotalItems.value = response.data.totalRecords || 0;
      fuxiangsanCurrentPage.value = response.data.pageNum || 1;
      fuxiangsanPageSize.value = response.data.pageSize || 10;
    } else {
      ElMessage.error(response.data.info || '获取赋像散订单列表失败');
    }
  } catch (error) {
    console.error('获取赋像散订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取赋像散订单列表失败，请检查网络连接');
    }
  }
};

// 批量订单查询
const fetchBulkOrders = async () => {
  try {
    const userId = localStorage.getItem('userId')
    const params = {
      userId: userId,
      pageNum: bulkCurrentPage.value,
      pageSize: bulkPageSize.value,
    };
    
    // 处理日期范围
    if (selectedDate.value && selectedDate.value.length === 2) {
      params.startDate = selectedDate.value[0];
      params.endDate = selectedDate.value[1];
    }

    if (selectedCompany.value) params.company = selectedCompany.value;
    if (selectedLensModel.value) params.lensModel = selectedLensModel.value;
    
    const response = await axios.get('/api/v1/user/bulkorder', {
      params,
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    if (response.data.code === '200') {
      // 确保将返回的数据正确赋值
      allBulkOrders.value = response.data.data || [];
      bulkTotalItems.value = response.data.totalRecords || 0;
      bulkCurrentPage.value = response.data.pageNum || 1;
      bulkPageSize.value = response.data.pageSize || 10;
    } else {
      ElMessage.error(response.data.info || '获取批量订单列表失败');
    }
  } catch (error) {
    console.error('获取批量订单列表失败:', error);
    if (error.response && error.response.status === 401) {
      return;
    } else {
      ElMessage.error('获取批量订单列表失败，请检查网络连接');
    }
  }
};

// 新增：根据订单类型请求后端获取创建时间
const fetchCreatedTime = async (row) => {
  let endpoint = '';
  if (activeTab.value === 'regular') {
    endpoint = '/api/v1/user/order/createdTime';
  } else if (activeTab.value === 'fuxiangsan') {
    endpoint = '/api/v1/user/scatterorder/createdTime';
  } else if (activeTab.value === 'bulk') {
    endpoint = '/api/v1/user/bulkorder/createdTime';
  }
  try {
    const res = await axios.get(endpoint, {
      params: { Id: row.id },
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
    if (res.data.code === '200') {
      return res.data.data; // createdAt 字符串
    }
  } catch (e) {
    console.error('获取创建时间失败', e);
  }
  return null;
};

// 将字符串格式转换为 Date
const parseDateTime = (str) => {
  if (!str) return null;
  return new Date(str.replace(/-/g, '/')); // 兼容 Safari
};

// 处理删除订单按钮点击事件
const handleDelete = async (row) => {
  try {
    const createdAtStr = await fetchCreatedTime(row);
    if (!createdAtStr) {
      ElMessage.error('无法获取订单创建时间');
      return;
    }
    const createDate = parseDateTime(createdAtStr);
    const hoursDiff = (Date.now() - createDate.getTime()) / (1000 * 60 * 60);
    if (hoursDiff > 1) {
      ElMessage.warning('订单创建时间已超过1小时，无法取消。如果想要取消订单，请联系客服。');
      return;
    }
    
    // 显示确认对话框
    await ElMessageBox.confirm('确认取消该订单吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    });
    
    let endpoint = '';
    // 根据当前标签页确定使用的API端点
    if (activeTab.value === 'regular') {
      endpoint = '/api/v1/user/order';
    } else if (activeTab.value === 'fuxiangsan') {
      endpoint = '/api/v1/user/scatterorder';
    } else if (activeTab.value === 'bulk') {
      endpoint = '/api/v1/user/bulkorder';
    }
    
    const response = await axios.delete(`${endpoint}?Id=${row.id}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });
    
    if (response.data.code === '200') {
      ElMessage.success('取消成功');
      // 根据当前标签页刷新对应的订单列表
      if (activeTab.value === 'regular') {
        fetchOrders();
      } else if (activeTab.value === 'fuxiangsan') {
        fetchFuxiangsanOrders();
      } else if (activeTab.value === 'bulk') {
        fetchBulkOrders();
      }
    } else {
      ElMessage.error(response.data.info);
    }
  } catch (error) {
    if (error !== 'cancel') {
      console.error('取消订单失败:', error);
      ElMessage.error('取消失败，请重试');
    }
  }
};

// 处理编辑订单按钮点击事件
const handleEdit = async (row) => {
  const createdAtStr = await fetchCreatedTime(row);
  if (!createdAtStr) {
    ElMessage.error('无法获取订单创建时间');
    return;
  }
  const createDate = parseDateTime(createdAtStr);
  const hoursDiff = (Date.now() - createDate.getTime()) / (1000 * 60 * 60);
  if (hoursDiff > 1) {
    ElMessage.warning('订单创建时间已超过1小时，无法编辑。如果想要修改订单，请联系客服。');
    return;
  }

  try {
    // 根据当前标签页，添加额外的索引和分页信息
    const modifiedRow = { ...row };
    
    if (activeTab.value === 'regular') {
      modifiedRow.index = filteredOrders.value.findIndex(order => order.id === row.id);
      modifiedRow.currentPage = currentPage.value;
      modifiedRow.pageSize = pageSize.value;
      orderEditComponent.value.handleEdit(modifiedRow);
    } else if (activeTab.value === 'fuxiangsan') {
      modifiedRow.index = filteredFuxiangsanOrders.value.findIndex(order => order.id === row.id);
      modifiedRow.currentPage = fuxiangsanCurrentPage.value;
      modifiedRow.pageSize = fuxiangsanPageSize.value;
      orderEditComponent.value.handleEditFuxiangsan(modifiedRow);
    } else if (activeTab.value === 'bulk') {
      modifiedRow.index = filteredBulkOrders.value.findIndex(order => order.id === row.id);
      modifiedRow.currentPage = bulkCurrentPage.value;
      modifiedRow.pageSize = bulkPageSize.value;
      orderEditComponent.value.handleEditBulk(modifiedRow);
    }
  } catch (error) {
    console.error('编辑订单失败:', error);
    ElMessage.error('编辑订单失败，请重试');
  }
};

// 编辑成功后刷新订单列表
const handleEditSuccess = () => {
  // 根据当前标签页刷新对应的订单列表
  if (activeTab.value === 'regular') {
    fetchOrders();
  } else if (activeTab.value === 'fuxiangsan') {
    fetchFuxiangsanOrders();
  } else if (activeTab.value === 'bulk') {
    fetchBulkOrders();
  }
};

// 编辑取消后的处理
const handleEditCancel = () => {
  console.log('编辑取消');
};

// 查询和重置
const handleSearch = () => {
  // 统一重置各分页至第一页（便于保持分页正确性）
  currentPage.value = 1;
  fuxiangsanCurrentPage.value = 1;
  bulkCurrentPage.value = 1;

  // 仅调用当前标签页对应的查询接口
  if (activeTab.value === 'regular') {
    fetchOrders();
  } else if (activeTab.value === 'fuxiangsan') {
    fetchFuxiangsanOrders();
  } else if (activeTab.value === 'bulk') {
    fetchBulkOrders();
  }
};

const resetSearch = () => {
  selectedDate.value = null;

  // 清空所有筛选条件
  selectedPatientName.value = '';
  selectedCompany.value = '';
  selectedLensModel.value = '';

  // 统一重置分页并重新查询三类订单
  currentPage.value = 1;
  fuxiangsanCurrentPage.value = 1;
  bulkCurrentPage.value = 1;

  fetchOrders();
  fetchFuxiangsanOrders();
  fetchBulkOrders();
};

// 查看订单详情
const showOrderDetails = (row) => {
  if (orderDetailComponent.value) {
    // 根据当前标签页类型选择合适的函数
    orderDetailComponent.value.showOrderDetails(row, activeTab.value);
  }
};

// 添加处理物流查询的函数
const checkTracking = (row) => {
  if (!row.trackingNumber) {
    ElMessage.warning('该订单没有物流编号');
    return;
  }
  
  // 提取手机号后四位
  let phoneLastFour = '';
  if (row.phone && row.phone.length >= 4) {
    phoneLastFour = row.phone.slice(-4);
  }
  
  // 跳转到物流查询页面并传递参数
  router.push({
    path: '/mail',
    query: {
      trackingNumber: row.trackingNumber,
      phoneNumber: phoneLastFour
    }
  });
};

onMounted(() => {
  // 加载初始数据
  fetchOrders();
  if (activeTab.value === 'fuxiangsan') {
    fetchFuxiangsanOrders();
  } else if (activeTab.value === 'bulk') {
    fetchBulkOrders();
  }
  
  // 检查箭头可见性
  nextTick(() => {
    checkArrowsVisibility();
    // 添加滚动监听
    if (tabsContainer.value) {
      tabsContainer.value.addEventListener('scroll', checkArrowsVisibility);
    }
    // 添加窗口大小变化监听
    window.addEventListener('resize', updateScreenWidth);
  });
  
  // 添加日期选择器移动端样式
  const datepickerStyle = document.createElement('style');
  datepickerStyle.textContent = `
    /* 移动端日期选择器面板适配 */
    @media screen and (max-width: 768px) {
      .el-picker-panel {
        max-width: 90vw !important;
        width: 90vw !important;
        min-width: 0 !important;
      }
      
      .el-date-picker {
        width: 90vw !important;
      }
      
      .el-date-range-picker__content {
        padding: 5px !important;
      }
      
      .el-date-range-picker__header {
        margin-bottom: 5px !important;
        height: 30px !important;
        line-height: 30px !important;
      }
      
      .el-date-range-picker__header div {
        margin-right: 0 !important;
        padding-left: 0 !important;
      }
      
      .el-date-range-picker__header button {
        padding: 0 5px !important;
      }
      
      .el-picker-panel__icon-btn {
        margin: 0 2px !important;
        width: 20px !important;
        height: 20px !important;
      }
      
      .el-date-table {
        font-size: 12px !important;
      }
      
      .el-date-table td {
        padding: 0 !important;
        height: 28px !important;
      }
      
      .el-date-table td div {
        height: 28px !important;
        line-height: 28px !important;
        padding: 0 !important;
      }
      
      .el-date-range-picker__content.is-left,
      .el-date-range-picker__content.is-right {
        width: 50% !important;
        min-width: 0 !important;
      }
      
      .el-date-range-picker__time-header {
        padding: 5px !important;
      }
      
      .el-date-table th {
        padding: 5px 0 !important;
      }
    }
    
    /* 超小屏幕（<600px）日期选择器上下布局 */
    @media screen and (max-width: 600px) {
      /* 调整日期范围选择器布局为上下结构 */
      .el-date-range-picker {
        width: 90vw !important;
        min-width: 0 !important;
      }
      
      .el-date-range-picker .el-picker-panel__body {
        min-width: 0 !important;
        width: 100% !important;
      }
      
      .el-date-range-picker .el-picker-panel__body-wrapper {
        flex-direction: column !important;
      }
      
      .el-date-range-picker__content.is-left,
      .el-date-range-picker__content.is-right {
        width: 100% !important;
        float: none !important;
        border-right: none !important;
        border-left: none !important;
      }
      
      .el-date-range-picker__content.is-right {
        border-top: 1px solid #e4e4e4 !important;
        padding-top: 10px !important;
        margin-top: 5px !important;
      }
      
      .el-date-range-picker__header {
        margin-bottom: 3px !important;
      }
      
      /* 减小日期表格大小 */
      .el-date-table td {
        height: 24px !important;
      }
      
      .el-date-table td div {
        height: 24px !important;
        line-height: 24px !important;
      }
      
      /* 调整底部按钮区域 */
      .el-picker-panel__footer {
        padding: 5px !important;
      }
      
      .el-picker-panel__footer .el-button {
        padding: 5px 10px !important;
        font-size: 12px !important;
      }
    }
  `;
  document.head.appendChild(datepickerStyle);
});

// 监听窗口大小变化，重新检查箭头可见性
watch(() => isMobile.value, () => {
  nextTick(checkArrowsVisibility);
});

// 组件销毁时清除监听
onUnmounted(() => {
  if (tabsContainer.value) {
    tabsContainer.value.removeEventListener('scroll', checkArrowsVisibility);
  }
  window.removeEventListener('resize', updateScreenWidth);
});

// 更新样式
const style = document.createElement('style');
style.textContent = `
.edit-order-dialog {
  width: 1400px !important;
  max-width: 95vw !important;
  box-sizing: border-box;
}

.edit-order-dialog .el-message-box__content {
  padding: 20px;
  max-height: 85vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.edit-order-form .form-section {
  margin-bottom: 25px;
  background-color: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.05);
}

.edit-order-form .form-section h3 {
  margin: 0 0 15px 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
  color: #303133;
  font-size: 16px;
  font-weight: bold;
}

.edit-order-form .beta-history-section {
  padding: 20px 24px 24px;
  border: 1px solid #dce9f5;
  border-radius: 8px;
  background: #f8fbff;
  box-shadow: 0 3px 10px rgba(64, 158, 255, 0.08);
}

.edit-order-form .beta-history-section h3 {
  color: #24557d;
  border-bottom-color: #cfe0ef;
}

.edit-order-form .beta-history-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}

.edit-order-form .beta-history-item {
  min-width: 0;
  padding: 16px 18px;
  border: 1px solid #dfe8f1;
  border-left: 3px solid #409eff;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(31, 78, 121, 0.05);
}

.edit-order-form .beta-history-label {
  color: #303133;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.6;
}

.edit-order-form .beta-history-radio {
  display: flex;
  gap: 24px;
  margin-top: 12px;
}

.edit-order-form .beta-history-radio label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: #606266;
  font-size: 14px;
  cursor: pointer;
}

.edit-order-form .beta-history-radio input[type="radio"] {
  width: 14px;
  height: 14px;
  margin: 0;
  accent-color: #409eff;
}

.edit-order-form .beta-history-duration {
  display: grid;
  grid-template-columns: 84px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-width: 0;
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px dashed #dfe8f1;
}

.edit-order-form .beta-history-sublabel {
  width: auto;
  padding: 0;
  color: #606266;
  font-size: 13px;
  text-align: right;
  white-space: nowrap;
}

.edit-order-form .beta-duration-control {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.edit-order-form .beta-duration-control .el-input__inner {
  flex: 0 0 88px;
  width: 88px;
  min-width: 88px;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  padding-left: 12px;
  padding-right: 28px;
  text-align: left;
}

.edit-order-form .beta-duration-unit {
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}

.edit-order-form .beta-history-elapsed {
  flex-basis: 100%;
  color: #409eff;
  font-size: 12px;
  line-height: 1.4;
}

.edit-order-form .form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-order-form .form-row.compact {
  gap: 8px;
  margin-bottom: 10px;
}

.edit-order-form .form-item {
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
}

.edit-order-form .form-item.full-width {
  flex: 1 1 100%;
}

.edit-order-form .form-item label {
  width: 70px;
  text-align: right;
  padding-right: 8px;
  color: #606266;
  white-space: nowrap;
  font-size: 14px;
}

.edit-order-form .form-item .el-input__inner {
  flex: 1;
  height: 32px;
  line-height: 32px;
  padding: 0 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  min-width: 80px;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edit-order-form .form-item .el-input__inner[readonly] {
  background-color: #f5f7fa;
  cursor: not-allowed;
}

.edit-order-form .form-item .el-textarea__inner {
  flex: 1;
  height: 60px;
  padding: 5px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #606266;
  background-color: #fff;
  resize: none;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

.edit-order-form .two-columns {
  display: flex;
  gap: 20px;
}

.edit-order-form .two-columns .column {
  flex: 1;
  min-width: 0;
}

.edit-order-form .cycloplegic-refraction-column {
  order: 1;
}

.edit-order-form .regular-refraction-column {
  order: 2;
}

.edit-order-form .trial-refraction-column {
  order: 3;
}

@media screen and (max-width: 1200px) {
  .edit-order-form .two-columns {
    flex-wrap: wrap;
  }

  .edit-order-form .two-columns .column {
    flex: 1 1 calc(50% - 10px);
    min-width: 360px;
  }

  .edit-order-form .basic-info .form-row {
    flex-wrap: wrap;
  }

  .edit-order-form .basic-info .form-item {
    flex: 1 1 calc(50% - 10px);
    min-width: 240px;
  }
}

.edit-order-form .eye-data-container {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.edit-order-form .eye-section {
  flex: 1;
  background-color: #f8f9fa;
  border-radius: 4px;
  padding: 12px;
}

.edit-order-form .eye-section h4 {
  margin: 0 0 8px 0;
  color: #606266;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 6px;
}

.edit-order-form .eye-section .form-row {
  flex-direction: column;
  gap: 8px;
  margin-bottom: 8px;
}

.edit-order-form .eye-section .form-row:last-child {
  margin-bottom: 0;
}

.edit-order-form .form-item select.el-input__inner {
  padding-right: 24px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23606266'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  appearance: none;
}

.edit-order-form .delivery-info .form-item .el-input__inner {
  min-width: 160px;
}

.edit-order-form .delivery-info .form-item .el-textarea__inner {
  min-height: 60px;
}

/* 优化标题和内容的间距 */
.edit-order-form .form-section > h3 {
  margin-bottom: 12px;
}

/* 优化表单项的垂直对齐 */
.edit-order-form .form-item {
  margin-bottom: 8px;
}

/* 确保所有输入框宽度合适 */
.edit-order-form .form-item .el-input__inner,
.edit-order-form .form-item .el-textarea__inner {
  width: 100%;
  box-sizing: border-box;
}
/* 针对小屏幕优化对话框内表单布局 */
@media screen and (max-width: 768px) {
  .edit-order-dialog {
    width: 98% !important;
    max-width: 95vw !important;
  }

  .edit-order-dialog .el-message-box__content {
    padding: 10;
  }

  .edit-order-form .form-section {
    padding: 10px;
    margin: 0 auto;
    max-width: 90%;
  }

  .edit-order-form .form-row {
    flex-direction: column;
    gap: 8px;
  }

  .edit-order-form .form-item {
    width: 100%;
  }

  .edit-order-form .form-item label {
    width: 60px;
    font-size: 12px;
  }

  .edit-order-form .form-item .el-input__inner,
  .edit-order-form .form-item .el-textarea__inner {
    width: 100%;
    min-width: 0;
    font-size: 12px;
  }

  .edit-order-form .beta-history-section {
    padding: 16px;
    max-width: none;
  }

  .edit-order-form .beta-history-grid {
    grid-template-columns: 1fr;
  }

  .edit-order-form .beta-history-item {
    padding: 14px;
  }

  .edit-order-form .beta-history-duration {
    grid-template-columns: 76px minmax(0, 1fr);
  }

  .edit-order-form .beta-duration-control .el-input__inner {
    flex: 1 1 88px;
    width: auto;
    min-width: 72px;
  }

  .edit-order-form .two-columns {
    flex-direction: column;
    gap: 10px;
  }

  .edit-order-form .eye-data-container {
    flex-direction: column;
    gap: 10px;
  }

  .edit-order-form .eye-section {
    padding: 8px;
  }

  .edit-order-form .eye-section h4 {
    font-size: 13px;
  }
  .el-message-box__container {
    display: block !important; /* 覆盖 Element UI 的 flex 设置 */
  }
}
`;
document.head.appendChild(style);
</script>
